export enum ItemTypes {
  MATERIAL_GROUP = 'material-group',
  MATERIAL = 'material',

  PROPERTY_TEASER = 'property-teaser'
}